import { createSlice } from '@reduxjs/toolkit';
import LangJson from './lang.json';
import * as JSTool from './JSTool';

const LANG = 'en';
export const settingObj = {
    showLogoAni: true,
    showMenu: false,
    menuId: '',
    navIndex: 0,
    navForceBlack: false,
    lang: LANG,
}

export const settingSlice = createSlice({
    name: 'setting',
    initialState: {
        navIndex: 0,
        showToast: null,
        showLoading: false,
        showFeedSuccessAlert: false,
        lang: LANG,
        langDic: getLangDic(LANG),
        fontFM: 'Lexend Deca',
        isMobile: false,
        showVideoAlert: null,
    },
    reducers: {
        setIsMobile: (state, action) => {
            state.isMobile = action.payload;
        },
        
        setNavIndex: (state, action) => {
            state.navIndex = action.payload;
            settingObj.navIndex = action.payload;
            settingObj.showLogoAni = false;
        },

        showLoading: (state, action) => {
            state.showLoading = action.payload;
        },

        showToast: (state, action) => {
            state.showToast = action.payload;
        },

        showFeedSuccessAlert: (state, action) => {
            state.showFeedSuccessAlert = action.payload;
        },

        showVideoAlert: (state, action) => {
            state.showVideoAlert = action.payload;
        },

        setLanguage: (state, action) => {
            state.langDic = getLangDic(action.payload);
            state.lang = action.payload;
            settingObj.lang = action.payload;
            JSTool.saveLocalString('local_lang', action.payload);

            if(action.payload == 'en'){
                state.fontFM = 'Lexend Deca';
            }else{
                state.fontFM = 'Source Han Sans CN';
            }

            setTimeout(() => {
                JSTool.reloadAni();
            }, 300);
        },
    }
});

function getLangDic(l) {
    for (const key in LangJson) {
        if (key == l) {
            return LangJson[l];
        }
    }
    return null;
}

export const settingActions = settingSlice.actions
export default settingSlice.reducer
